<template>

  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" class="demo-form-inline">
        <el-form-item label="">
          <el-select v-model="value" placeholder="请选择">
             <el-option
               v-for="item in options"
               :key="item.value"
               :label="item.label"
               :value="item.value">
             </el-option>
           </el-select>
       </el-form-item>
        <el-form-item label=""><el-input v-model="keyword" placeholder="请输入昵称或者手机号 "></el-input></el-form-item>
        <el-form-item><el-button type="primary" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>

    <!--添加证书-->
    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加证书</el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" size="small" border style="width: 100%" v-loading="loading">
          <el-table-column prop="certificate_id" label="证书ID" ></el-table-column>
          <el-table-column prop="nick_name" label="昵称" ></el-table-column>
          <el-table-column prop="" label="证书图片" width="180">
            <template slot-scope="scope">
              <a :href="scope.row.img_url" target="_blank"><img v-img-url="hasImages(scope.row.img_url)" alt="" width="50px" /></a>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号码" ></el-table-column>
          <el-table-column prop="apply_status" label="审核状态">
            <template slot-scope="scope">
              <span>
                {{ scope.row.status_text }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="生成时间" ></el-table-column>
          <el-table-column fixed="right" label="操作" >
            <template slot-scope="scope">
              <div>
                <el-button @click="auditClick(scope.row.certificate_id,scope.row.status)" type="text" size="small">
                  审核
                </el-button>
                <el-button  @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="CertificateModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <!--修改-->
    <Edit v-if="open_edit" :open_edit="open_edit" :editform="CertificateModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

    <!-- 审核 -->

    <el-dialog
      title="提示"
      :visible.sync="audit_status"
      width="30%"
      >
      <el-radio-group v-model="status">
        <el-radio  label="0"  @change="changeStatus(0)">待审核</el-radio>
        <el-radio  label="1"  @change="changeStatus(1)">审核通过</el-radio>
        <el-radio  label="2"  @change="changeStatus(2)">审核不通过</el-radio> 
      </el-radio-group>
     
      <span slot="footer" class="dialog-footer">
      <el-button @click="audit_status = false">取 消</el-button>
      <el-button type="primary" @click="auditCret()">确 定</el-button>
      </span>
    </el-dialog>

  </div>
  
</template>

<script>
import PlusApi from '@/api/plus.js';
import Edit from './dialog/Edit.vue';
import Add from './dialog/Add.vue';
export default {
  components: {
    /*编辑组件*/
    Edit,
    Add
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      keyword: '',
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*是否打开添加弹窗*/
      open_add: false,
      /*当前编辑的对象*/
      CertificateModel: {
        certificateList: [],
        model: {}
      },
      select_id : '',
      // 审核框显示
      audit_status:false,
      status:'',
      select_status : '',
      /*审核状态*/
      options: [{
          value: 'all',
          label: '全部'
        }, {
          value: 'will',
          label: '待审核'
        }, {
          value: 'success',
          label: '审核通过'
        }, {
          value: 'fail',
          label: '审核不通过'
        }],
        value: 'all'
      }
    
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*获取数据*/
    getData() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.keyword = this.keyword;
      Params.status = this.value;
      PlusApi.certificateList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    hasImages(e) {
        if (e) {
          return e;
        } else {
          return '';
        }
    },
    //搜索
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getData();
    },

    /*打开弹出层编辑*/
    editClick(item) {
      this.open_edit = true;
      this.CertificateModel.model = item;
    },
    // 审核状态
    auditClick(res,item){
      this.select_id = res;
      this.status = item.toString();
      this.audit_status = true;

    },
    /*打开添加*/
    addClick() {
      this.open_add = true;
    },
    // 审核证书
    auditCret(){
      let self = this;
      let Params = {};
      Params.cert_id = this.select_id;
      Params.status = this.select_status;
      PlusApi.editCertificateStatus(Params, true)
        .then(data => {
          self.audit_status = false;
          self.getData();
        })
        .catch(error => {});
    },
    // 修改状态
    changeStatus(res){
      this.select_status = res
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/certificate/certificate/Certificate.vue